<div class="timeline-segment">
  @if (displaySegmentInfo()) {}
  @let track = currentTrack();
  @if (track && track.content) {
    <div class="segment-wrapper" [ngClass]="trackWrapperClasses()">
      <pv3-track-info
        [content]="track.content"
        [startedAt]="track.startedAt"
        [showAlbumArt]="showAlbumArt()"
        [showPlayTime]="showPlayTime()"
      ></pv3-track-info>
    </div>
  }
  @let tlSegment = timelineSegment();
  @if (tlSegment && tlSegment.items && tlSegment.items.length > 0) {
    @for (segment of tlSegment.items; track segment.item.uid) {
      <div class="segment-wrapper" [ngClass]="trackWrapperClasses()">
        @if (segment.type === 'SegmentItem' && segment.item.content) {
          <pv3-track-info
            [content]="segment.item.content"
            [startedAt]="segment.addedAt"
            [showAlbumArt]="showAlbumArt()"
            [showPlayTime]="showPlayTime()"
          ></pv3-track-info>
        }
      </div>
    }
  }
</div>
